import axios from 'axios';

export const fetchAllLanguagesFulfilled = (value, myThis) => ({
  type: 'FETCH_ALL_LANGUAGES_FULFILLED',
  payload: value,
  myThis
});

export const fetchAllLanguages = myThis => (
  (dispatch) => {
    axios({
      url: routes().languages,
      method: 'GET',
      headers: getHeaders()
    }).then((response) => {
      dispatch(fetchAllLanguagesFulfilled(response.data, myThis));
    }).catch((err) => {
      console.error(err);
    });
  }
);

export const updatePreferedLanguages = value => ({
  type: 'UPDATE_PREFERED_LANGUAGES',
  payload: value
});

export const savePreferedLanguages = isoCodes => (
  (dispatch) => {
    axios({
      url: routes().preferred_languages,
      method: 'POST',
      headers: getHeaders(),
      data: { content_languages: isoCodes }
    }).then((response) => {
      dispatch(updatePreferedLanguages(response.data.preferred));
      setNoticeSuccess(I18n.t('messages.settings_changed'));
    }).catch((err) => {
      console.error(err);
    });
  }
);

export const addPreferedLanguages = (value, myThis) => ({
  type: 'ADD_PREFERED_LANGUAGE',
  payload: value,
  myThis
});

export const removePreferedLanguage = (value, myThis) => ({
  type: 'REMOVE_PREFERED_LANGUAGE',
  payload: value,
  myThis
});

export const updateLanguaeFilterValue = value => ({
  type: 'UPDATE_LANGUAGE_FILTER_VALUE',
  payload: value
});

export const updateSelectedLanguaes = value => ({
  type: 'UPDATE_SELECTED_LANGUAGES',
  payload: value
});

export const activateActionButton = button => ({
  type: button === 'ADD_BUTTON' ? 'UPDATE_ADD_BUTTON' : 'UPDATE_REMOVE_BUTTON',
  payload: true
});

export const deactivateActionButton = button => ({
  type: button === 'ADD_BUTTON' ? 'UPDATE_ADD_BUTTON' : 'UPDATE_REMOVE_BUTTON',
  payload: false
});
